import { IMessageProps, Message } from 'Components/Core';
import { hasEmptyValue, hasNonEmptyValue } from 'Lib/Any';
import { IconLock, IconSyncProblem } from 'Lib/Icons';
import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

/**
 * Displays messages related to the update section in general.
 * Sits within WorksheetBatchUpdateUpdateDataSection
 */
const WorksheetBatchUpdateUpdateDataMessagesSection: React.FC = () => {
  const showReadOnlyMessage = useSelector(
    (state) =>
      !state.worksheetBatchUpdate.status.refreshingWorksheets &&
      Object.values(state.worksheetBatchUpdate.worksheets).some(
        (w) => w.status.readonly.locked && !w.status.readonly.uncheckAllowed
      )
  );
  const showCanBeUncheckedMessage = useSelector(
    (state) =>
      !state.worksheetBatchUpdate.status.refreshingWorksheets &&
      Object.values(state.worksheetBatchUpdate.worksheets).some(
        (w) => w.status.readonly.locked && w.status.readonly.uncheckAllowed
      ) &&
      // message only relevant if we are applying update changes
      Object.values(state.worksheetBatchUpdate.fields).some((f) => f.update)
  );
  const showUpdateFailureMessage = useSelector((state) =>
    Object.keys(state.worksheetBatchUpdate.worksheets).some((w) =>
      hasNonEmptyValue(state.worksheetBatchUpdate.updateFailures[w])
    )
  );

  const messages: Array<PropsWithChildren<IMessageProps>> = [];

  if (showReadOnlyMessage)
    messages.push({
      children: (
        <p>
          Worksheets indicated with <IconLock /> that cannot be selected are read-only and will not be updated.
        </p>
      ),
      severity: 'info',
    });
  if (showCanBeUncheckedMessage)
    messages.push({
      children: (
        <p>
          Worksheets indicated with <IconLock /> that can be selected are read-only, but will be unchecked prior to
          applying changes.
        </p>
      ),
      severity: 'info',
    });
  if (showUpdateFailureMessage)
    messages.push({
      children: (
        <p>
          Worksheets indicated with <IconSyncProblem /> were not updated as expected.
        </p>
      ),
      severity: 'warning',
    });

  if (hasEmptyValue(messages)) return null;
  return (
    <div className="WorksheetBatchUpdateUpdateDataSection-Messages">
      {messages.map((m, i) => (
        <Message {...m} key={i} />
      ))}
    </div>
  );
};
export default WorksheetBatchUpdateUpdateDataMessagesSection;
export { WorksheetBatchUpdateUpdateDataMessagesSection };
